import PageTemplate from '@/components/AppointmentTypesByPhaseList/components/PageTemplate';
import { useAppointmentTypeScheduleExpectationCyclesWithinLookahead } from '@/hooks/useAppointmentTypes/useAppointmentTypes';

import UnexpectedAppointments from '../UnexpectedAppointments/UnexpectedAppointments';

import { Props } from './types';

const AppointmentTypeScheduleExpectationCyclesWithinLookahead = ({
  activeAppointmentTypeId,
  onSeeExpectationDetails,
  phase,
  timeZone
}: Props) => {
  const { id: phaseId } = phase;

  const { data, error, isError, isPending } =
    useAppointmentTypeScheduleExpectationCyclesWithinLookahead(phaseId);

  return (
    <>
      <UnexpectedAppointments phase={phase} />
      <PageTemplate
        activeAppointmentTypeId={activeAppointmentTypeId}
        data={data}
        error={error}
        isError={isError}
        isLoading={isPending}
        onSeeExpectationDetails={onSeeExpectationDetails}
        phase={phase}
        timeZone={timeZone}
        uiMode="default"
      />
    </>
  );
};

export default AppointmentTypeScheduleExpectationCyclesWithinLookahead;
